<template>
  <div>
    <ed-empresa :intTabelaPrecoId="$route.params.intId" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdEmpresa from "@/components/cadastro/tabelaPreco/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdEmpresa },
  mounted() {
    if(!this.$route.params.intId){
      this.$router.push({ name: "cadastro.preco.register" });
    }
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>